module.exports = __webpack_public_path__ + "img/feature_buy_zh.2da33b68.png";